var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddPageSide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8328 3.39197H4.83203C4.63312 3.39197 4.44235 3.47099 4.3017 3.61164C4.16105 3.75229 4.08203 3.94306 4.08203 4.14197V20.642C4.08203 20.8409 4.16105 21.0316 4.3017 21.1723C4.44235 21.313 4.63312 21.392 4.83203 21.392H18.3328C18.4313 21.392 18.5288 21.3726 18.6198 21.3349C18.7108 21.2972 18.7935 21.2419 18.8631 21.1723C18.9327 21.1027 18.988 21.02 19.0257 20.929C19.0634 20.838 19.0828 20.7405 19.0828 20.642V8.64197M13.8328 3.39197L19.0828 8.64197M13.8328 3.39197V8.64197H19.0828M9.33276 14.642H13.8328M11.5828 12.392V16.892",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPageSide);
export default __webpack_public_path__ + "static/media/add-page-side.41f62fed.svg";
export { ForwardRef as ReactComponent };